<template>
  <div class="content-nav main clearfix">
    <nuxt-link :to="`/room/${roomId}`">观点</nuxt-link>
    <nuxt-link :to="`/article/list/${teacherId}`">
      文章
      <img v-show="!isCurrentTeacher && !isRoomGuest && articleCount > 0" src="~assets/order-icon.png" alt="藏金阁" />
    </nuxt-link>
    <!-- <nuxt-link :to="`/vip/detail/${teacherId}`" v-if="trainingId">
      特训班
      <img v-show="!isCurrentTeacher && !isRoomGuest && vipCount" src="~assets/order-icon.png" alt="特训班" />
    </nuxt-link>
    <span @click="showTip" v-else>特训班</span> -->
    <nuxt-link :to="`/question/list/${teacherId}`">问答</nuxt-link>
    <!-- <span class="grey">视频</span> -->
    <nuxt-link :to="`/intro/${teacherId}`">老师介绍</nuxt-link>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Dialog from '@/utils/Dialog'

export default {
  name: 'component-nav',
  methods: {
    showTip () {
      if (this.isCurrentTeacher) {
        Dialog.alert('您尚未创建特训班，是否前去创建？', {
          showCancelButton: true
        }).then(() => {
          this.$router.push('/vip/edit')
        })
      } else {
        Dialog.alert('老师尚未创建特训班')
      }
    }
  },
  computed: {
    ...mapState('teacher', {
      roomId: state => state.data.roomId,
      teacherId: state => state.data.id,
      articleCount: state => state.saleArticle.length,
      vipCount: state => !!state.saleVip,
      trainingId: state => state.data.trainingId
    }),
    ...mapGetters({
      isCurrentTeacher: 'teacher/isTeacher',
      isRoomGuest: 'room/isGuest'
    })
  }
}
</script>

<style lang="less" scoped>
.content-nav {
  background: #fff; margin-bottom: 15px;
  a, span {
    float: left; width: 16.66666666%; text-align: center; line-height: 60px; border-bottom: 4px solid #fefefe; font-size: 16px; color: #666; padding-top: 4px; cursor: pointer;
    &:hover {
      color: #e03a3c;
    }
    &.grey {
      color: #cccccc; cursor: default;
    }
    &.nuxt-link-active { border-color:#e03a3c; }
  }
}
</style>
